import styled from "styled-components";

export const CommonIconButton = styled.button`
  border: none;
  background-color: transparent;

  border-radius: 4px;

  cursor: pointer;
`;

export const CommonButtonStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 150px;
  height: 40px;
  border: none;
  box-shadow: 0 0 3px;

  border-radius: 4px;
  font-size: 18px;

  transition: 200ms;

  background: rgb(0, 172, 238);
  background: linear-gradient(
    0deg,
    rgba(0, 172, 238, 1) 0%,
    rgba(2, 126, 251, 1) 100%
  );
  color: white;
  &:active {
    transform: scale(0.9);
  }

  cursor: pointer;
`;
